import axios from "axios";
import { Auth } from "../services/authService";
const { BACKEND_URL } = require("../config/config");

const authController = new Auth();

export async function obtenerSms(id) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/smsporexpediente/${id}`;

  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function enviarSms(data, id) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/smsporexpediente/`;

  return axios.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}


export async function responderSms(data, id) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/smsporexpediente/${id}`;

  return axios.put(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

export function obtenerNotificacionesNoLeidasPorExpediente( idExpediente ) {
  const token = authController.getAccessToken();

  if (idExpediente && token) {
    const url = `${BACKEND_URL}/smsunreadporexpediente/${idExpediente}`;

    return axios.get(url, {
      headers: {
        Authorization: token,
      },
    });
  }
}

export function obtenerMensajesNoLeidosPorExpediente( idExpediente ) {
  const token = authController.getAccessToken();

  if (idExpediente && token) {
    const url = `${BACKEND_URL}/mensajesunreadporexpediente/${idExpediente}`;

    return axios.get(url, {
      headers: {
        Authorization: token,
      },
    });
  }
}


export function marcarComoLeido( idMensaje )  {
  const token = authController.getAccessToken();

  if (idMensaje && token) {
    const url = `${BACKEND_URL}/markAsReadSms/${idMensaje}`;

    return axios.put(url, {},{
      headers: {
        Authorization: token,
      },
    });
  }
}
